import { useEffect } from "react";
import { DefaultModeInitialState, ModeTransitionProps } from "../mode";
import { useCurrentArea, useCurrentScene } from "../mode-data-context";
import { useTagsManagementContext } from "./tags-management-context";

/** @returns The transition to enter the tags management mode */
export function TagsManagementTransition({
  onCompleted,
}: ModeTransitionProps<DefaultModeInitialState>): null {
  const { area } = useCurrentArea();
  const currentScene = useCurrentScene();

  // When transitioning to the TagsManagement mode, synchronize the active area
  // of the mode with the one in the app store
  const { activeAreaId, setActiveAreaId, clearSelection, setVisibleSheets } =
    useTagsManagementContext();
  useEffect(() => {
    setActiveAreaId(area?.id);
    setVisibleSheets(currentScene.activeSheets);
  }, [area, currentScene.activeSheets, setActiveAreaId, setVisibleSheets]);

  useEffect(() => {
    if (activeAreaId === area?.id) {
      clearSelection();
      onCompleted();
    }
  }, [activeAreaId, area?.id, onCompleted, clearSelection]);

  return null;
}
